import { GridNine } from "@phosphor-icons/react";
import { Button } from "@replicate/ui";
import type { Model, Prediction } from "../../types";

export function LinkToPlayground({
  model,
  prediction,
}: {
  model: Model | null;
  prediction: Prediction | null;
}) {
  if (!model || !prediction) {
    return null;
  }

  const inputsEncoded = encodeURIComponent(JSON.stringify(prediction.input));

  return (
    <Button
      variant="outlined"
      startIcon={<GridNine size={16} />}
      render={
        // biome-ignore lint/a11y/useAnchorContent: handled by ariakit
        <a
          href={`https://replicate.com/playground?model=${model.owner}/${model.name}&inputs=${inputsEncoded}`}
        />
      }
    >
      <span>Iterate in playground</span>
    </Button>
  );
}
